var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var objectToArrayKeyValue = function (obj) { return Object.entries(obj).reduce(function (accumulator, current) {
    var newObj = {
        key: current[0],
        value: current[1],
    };
    return __spreadArrays(accumulator, [newObj]);
}, []); };
export var arrayKeyValueToObject = function (arr) { return arr.reduce(function (accumulator, current) {
    accumulator[current.key] = current.value;
    return accumulator;
}, {}); };
export var elementOfArrayCount = function (arr) { return arr.reduce(function (accumulator, current) {
    if (typeof accumulator[current] === 'undefined') {
        accumulator[current] = 1;
    }
    else {
        accumulator[current] += 1;
    }
    return accumulator;
}, {}); };
export var onValidateData = function (itemList) {
    var trimmedData = itemList.map(function (item) {
        item.key = item.key.trim();
        item.value = item.value.trim();
        return item;
    });
    var keyList = trimmedData.map(function (item) { return item.key; });
    // array of keys
    var keysListCount = elementOfArrayCount(keyList);
    // count key item of array and store to object
    var duplicatedKeys = Object.keys(keysListCount).filter(function (key) { return keysListCount[key] > 1; });
    // find key(s) that have item more than 1 (duplicated keys)
    var inputIndexErrors = trimmedData.reduce(function (accumulator, current, idx) {
        if (duplicatedKeys.includes(current.key)) {
            accumulator.push(idx);
        }
        return accumulator;
    }, []);
    // store index list of state that duplicated
    return [trimmedData, inputIndexErrors];
};
//# sourceMappingURL=index.js.map